// extracted by mini-css-extract-plugin
export default {"caption":"caption--dD0Ja","text01":"text01--tp02q","text03":"text03--bHSaI","error":"error--E4znN"};